import { mapToLabelValue } from "@features/mx/device-management/utils";
import { IconButton } from "@shared/components/IconButton";
import { GenericSelect } from "@shared/components/Select";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { useEffect, useState } from "react";
import { toast } from "@shared/ui/use-toast";
import { useValidationContext } from "../../context";
import { usePutMeterReadingRevisit, useReasonCodeList } from "../../hooks";
import { logEvent } from "@shared/analytics/analytics";

interface RevisitReadingProps {
  open: boolean;
  onClose: () => void;
}

export const RevisitReadingDialog: React.FC<RevisitReadingProps> = ({
  open,
  onClose,
}) => {
  const { codeId, readingId, goToNextReading } = useValidationContext();
  const [selectedReason, setSelectedReason] = useState<string>("");
  console.log("codeId", codeId);

  const { data: reasonCodeList } = useReasonCodeList(codeId);

  const { mutate: putMeterReadingRevisit } =
    usePutMeterReadingRevisit(readingId);

  const list = mapToLabelValue(reasonCodeList, "reasonCode", "id");

  const handleRevisit = () => {
    if (selectedReason) {
      putMeterReadingRevisit(
        { reason_code: selectedReason },
        {
          onSuccess: () => {
            toast({
              variant: "default",
              title: "Success",
              description: "Reading marked for revisit successfully",
            });
            logEvent("MX Reading marked for revisit", {
              reason: selectedReason,
            });
            goToNextReading();
            setSelectedReason("");
            onClose();
          }
        }
      );
    }
  };

  const handleClose = () => {
    setSelectedReason("");
    onClose();
  };

  useEffect(() => {
    if (!open) {
      // Reset local state if dialog is closed
      setSelectedReason("");
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md rounded-xl p-6">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            Mark for Revisit
          </DialogTitle>
          <p className="text-sm text-muted-foreground mt-1">
            Select a reason code for revisiting this reading.
          </p>
        </DialogHeader>

        <div className="mt-4">
          <label
            htmlFor="reasonCode"
            className="text-sm font-medium block mb-1"
          >
            Reason Code
          </label>
          <GenericSelect
            placeholder="Select a reason code"
            options={list}
            value={selectedReason}
            onValueChange={(val: string) => setSelectedReason(val)}
          />
        </div>

        <DialogFooter className="mt-6 flex justify-end gap-3">
          <DialogClose asChild>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
          </DialogClose>
          <IconButton
            label="Revisit"
            disabled={!selectedReason}
            onClick={handleRevisit}
            className="bg-orange-300 text-white hover:bg-orange-400"
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
